import { CounterClockwiseSVG } from 'common/assets';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { Button } from './buttons';
import {
  ErrorViewContainer,
  ErrorContentContainer,
  ErrorActionContainer,
  RefreshContainer,
} from './styles';
import Text from './text';

interface Props {
  isLoading?: boolean;
  title?: string;
  subtitle?: string;
  vertical?: boolean;
}

export function BackButton() {
  const { t } = useTranslation();
  const { back } = useRouter();
  return (
    <Button
      onClick={back}
      startEnhancer={(color, size) => {
        return <CounterClockwiseSVG color={color} size={size} />;
      }}
      buttonType="secondary"
    >
      {t('common:back')}
    </Button>
  );
}

export default function UnauthorizedViewComponent(props: Props) {
  const { t } = useTranslation();
  const { vertical = true } = props;

  return (
    <DetailContainer>
      <ErrorViewContainer vertical={vertical ? 1 : 0}>
        <ErrorContentContainer vertical={vertical ? 1 : 0}>
          <Text variant="title1Bold" textAlign="center">
            403
          </Text>
          <SeparatorVertical $margin={24} />
          <Text variant="title2Bold">{t('error:403_title')}</Text>
          <SeparatorVertical $margin={8} />
          <Text variant="ParagraphLarge">{t('error:403_description')}</Text>
        </ErrorContentContainer>
        <ErrorActionContainer>
          <RefreshContainer>
            <BackButton />
          </RefreshContainer>
        </ErrorActionContainer>
      </ErrorViewContainer>
    </DetailContainer>
  );
}
